var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublicLiability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 28.05C31.6484 28.3166 32.344 28.4496 33.0451 28.441C33.7462 28.4324 34.4383 28.2824 35.08 28C36.1412 27.4717 37.1239 26.7986 38 26C38.9013 26.804 39.9112 27.4773 41 28C41.6259 28.2886 42.3055 28.4422 42.9947 28.4508C43.6838 28.4594 44.3671 28.3229 45 28.05V33.41C45 38.27 42.3 41.73 38 44C33.7 41.73 31 38.27 31 33.41V28.05Z",
    stroke: "#FAD238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36L37 38L41 33",
    stroke: "#FAD238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.66V31.5",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.0601V31.5001L7 35.0801C5.8313 35.4933 4.81926 36.2583 4.103 37.27C3.38674 38.2817 3.00142 39.4905 3 40.7301V42.5001C3 43.0305 3.21071 43.5392 3.58579 43.9143C3.96086 44.2893 4.46957 44.5001 5 44.5001H32.12",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.69 14.41C31.35 14.41 31.09 14.41 30.75 14.5C27.34 15.16 25.16 13.92 23.28 10.64C22.16 12.8 18.64 14.5 15.75 14.5C14.4023 14.521 13.0711 14.2011 11.88 13.57",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 27.5C27.2728 27.5 31.75 22.1274 31.75 15.5C31.75 8.87258 27.2728 3.5 21.75 3.5C16.2272 3.5 11.75 8.87258 11.75 15.5C11.75 22.1274 16.2272 27.5 21.75 27.5Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicLiability);
export default __webpack_public_path__ + "static/media/public_liability.ad6c9a618e03352548446aa86d898b6f.svg";
export { ForwardRef as ReactComponent };